<script>
	import { fade } from "svelte/transition";
	import { quadOut } from "svelte/easing";
	import { animationTime } from "./stores.js";

	export let selected = false;
	export let data = false;
	let chosen = false;

	const letters = ["A", "B", "C"];

	let answerQuestion = (i) => {
		chosen = !chosen;
		data.selected = i;
		setTimeout(() => {
			if (selected < 9) {
				selected++;
			} else {
				selected = "outro";
			}
		}, 1000);
	};
</script>

<div class="question">
	<h1
		in:fade={{
			y: 200,
			duration: $animationTime,
			delay: $animationTime + 20,
			easing: quadOut,
		}}
	>
		{data.question}
	</h1>
	<img
		in:fade={{
			y: 200,
			duration: $animationTime,
			delay: $animationTime + 270,
			easing: quadOut,
		}}
		src="/imgs/q{selected + 1}.jpg"
		alt={data.question}
	/>
	<div class="answers" class:unchosen={!chosen} class:chosen>
		{#each data.answers as answer, i}
			<button
				class="answer"
				on:click={() => {
					answerQuestion(i);
				}}
				class:selected={data.selected === i}
				class:missed={selected &&
					data.correct.indexOf(data.selected) === -1 &&
					data.correct.indexOf(i) > -1}
				class:correct={data.correct.indexOf(data.selected) > -1 &&
					data.selected === i}
				in:fade={{
					z: -100,
					duration: $animationTime,
					delay: $animationTime * 1.5 + $animationTime * 0.1 * i + 1,
					easing: quadOut,
				}}
			>
				<div class="icon">
					{letters[i]}
				</div>
				<div class="text">{answer}</div>
			</button>
		{/each}
	</div>
</div>

<style>
	.question {
		height: calc((var(--height) * 0.8) - var(--countHeight));
		display: grid;
		align-items: end;
		justify-items: center;
	}
	.answers {
		--height: 2em;
		width: 300px;
		margin: 0 auto 0.5em;
	}
	img {
		max-width: 200px;
	}

	.answer {
		width: 100%;
		background: none;
		cursor: pointer;
		border: none;
		display: grid;
		grid-template-columns: var(--height) 1fr;
		gap: 0.3em;
		margin-bottom: 0.5em;
	}

	.icon,
	.text {
		background: var(--grey);
		display: grid;
		line-height: 1.5em;
		padding: 0.25em;
		justify-items: center;
		transition: all 0.2s;
	}

	.chosen .answer .icon,
	.chosen .answer .text {
		opacity: 0.2;
	}
	.chosen .answer.selected .icon,
	.chosen .answer.selected .text,
	.no-touch .unchosen .answer:hover .icon,
	.no-touch .unchosen .answer:hover .text {
		opacity: 1;
		background: var(--accent);
		color: var(--white);
	}

	.chosen .answer.missed .icon,
	.chosen .answer.missed .text {
		opacity: 1;
		background: var(--correct);
		color: var(--white);
	}

	.chosen .answer.correct .icon,
	.chosen .answer.correct .text {
		opacity: 1;
		background: var(--correct);
		color: var(--white);
	}
</style>
